import React, { useState, useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";
import CameraWithOverlayVideo from "../CameraWithOverlayVideo";
import CarDamge from "../Car Damge";
import baseUrlNew from "../BaseUrl/index";
import { useLocation, useHistory } from "react-router-dom";
import SessionLoadingScreen from "../components/SessionLoadingScreen";

function ApiCall() {
  const [available, setavailable] = useState();
  const [loading, setloading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const id = location.state?.id;
  const car_name = location.state?.car_name;

  useEffect(() => {
    getuserStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const baseUrl = `${baseUrlNew.baseUrl}api/v1/check_product_photos/`;

  const getuserStatus = () => {
    axios
      .post(baseUrl, {
        pk: id,
      })
      .then((response) => {
        setavailable(response.data.data.available);
        setloading(false);
      })
      .catch(() => {
        setloading(false);
      });
  };

  const goBack = () => {
    history.push({
      pathname: "/inspection/carsteps",
      state: { id, car_name },
    });
  };

  if (loading) {
    return <SessionLoadingScreen onBack={goBack} />;
  }

  return available ? (
    <CarDamge id={id} car_name={car_name} />
  ) : (
    <CameraWithOverlayVideo
      id={id}
      close={setavailable}
      car_name={car_name}
    />
  );
}

const mapStateToProps = (state) => ({
  userId: state.cardata.data,
});
const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ApiCall);
